import { render, staticRenderFns } from "./PreViewImage.vue?vue&type=template&id=3d2084fa&scoped=true&"
import script from "./PreViewImage.vue?vue&type=script&lang=js&"
export * from "./PreViewImage.vue?vue&type=script&lang=js&"
import style0 from "./PreViewImage.vue?vue&type=style&index=0&id=3d2084fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2084fa",
  null
  
)

component.options.__file = "PreViewImage.vue"
export default component.exports